export default {
      id: "email-usage",
      viewBox: "0 0 480 480",
      url: "/assets/svg/" + "sprite.svg#email-usage",
      toString: function () {
        return this.url;
      }
    }